<div edlFocusTrap class="focus-trap-container">
<div class="modal-header">
  <h4 class="modal-title">Select Roles to Update</h4>
</div>
<div class="modal-body">
  <div class="row">
      <div class="col-sm-12">
          <fieldset>
              <legend class="visually-hidden">Select Roles to Update</legend>
              <ul class="row">
                  <li class="col-sm-4" *ngFor="let role of roles">
                      <div class="test">
                          <label class="form-label">
                              <input type="checkbox"
                                     [(ngModel)]="role.IsSelected"
                                     [ngModelOptions]="{ standalone: true }"
                                     [value]="role.RoleID"/>
                              {{ role.RoleName }}
                          </label>
                      </div>
                  </li>
              </ul>
              <hr>
              <div class="col-sm-12">
                  <button type="button" class="btn btn-link p-0" (click)="selectalll()">Select All</button> | <button type="button" class="btn btn-link p-0" (click)="deselectalll()">Deselect All</button>
                </div>
          </fieldset>
      </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="ok()">Ok</button>
  <button type="button" class="btn btn-info" (click)="cancel()">Cancel</button>
</div>
</div>